import * as React from 'react';
import { withAnalyticOnEvent } from 'react-shisell';
import styled from 'styled-components';
import { AnchorHTMLAttributes } from 'react';

const Anchor = styled.a`
  color: #454545;
  font-size: 1em;
`;

export type AnchorProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  analyticsExtras?: Record<string, string | undefined>;
};

export const AnchorWithAnalytics = withAnalyticOnEvent<AnchorProps>({
  eventName: 'onClick',
  analyticName: 'SH_WEB_EVENT',
  extras: { ActionId: 'Click' },
})(Anchor);

const AnchorWithAnalyticsWrapper: React.FC<AnchorProps> = (props) => (
  <AnchorWithAnalytics {...props} analyticsExtras={{ ElementId: props.id, ...props.analyticsExtras }} />
);

export default AnchorWithAnalyticsWrapper;



// WEBPACK FOOTER //
// ./packages/platform-common-ui/components/AnchorWithAnalytics.tsx